import React from 'react';
import {NavLink, withRouter} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser';
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell';
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle';

import {User, Toast} from 'Services';
import Me from 'Services/Api/Me/Me';
import {HeaderNotifications} from 'Components/Comms';
import ServiceSwitcher from 'Components/Services/ServiceSwitcher';

class Header extends React.Component {
    /**
     * @var openRef
     * @type {HTMLDivElement}
     */
    openRef = null;

    /**
     * @var state
     * @type {{showUserMenu: boolean, unread: boolean, showMobileMenu: boolean, user: null}}
     */
    state = {
        showUserMenu: false,
        showMobileMenu: false,
        user: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.setUser();

        User.on('change', this.setUser);

        document.addEventListener('mousedown', this.handleCloseMenus);
        document.addEventListener('touchstart', this.handleCloseMenus);
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        User.removeListener('change', this.setUser);

        document.removeEventListener('mousedown', this.handleCloseMenus);
        document.removeEventListener('touchstart', this.handleCloseMenus);
    };

    /**
     * @method
     */
    setUser = () => this.setState({
        user: User.data,
    });

    /**
     * @method handleCloseMenus
     * @param {Event} event
     */
    handleCloseMenus = (event) => {
        if (!this.openRef || this.openRef.contains(event.target)) {
            return;
        }

        this.setState({
            showUserMenu: false,
        });
    };

    /**
     * @method handleUpdateTeam
     * @param {object} team
     * @param {boolean} hasUrl
     * @return {Promise<void>}
     */
    handleUpdateTeam = async (team, hasUrl = false) => {
        const request = await Me.updateTeam({
            team_id: team.id
        });

        if (!request.success) {
            return Toast.error();
        }

        this.setState({
            showUserMenu: false
        }, () => {
            if (!hasUrl) {
                this.props.history.push('/');
            }
        });

        return true;
    };

    /**
     * @method handleToggleUserMenu
     */
    handleToggleUserMenu = () => {
        this.setState({
            showUserMenu: !this.state.showUserMenu,
            showMobileMenu: false,
        });
    };

    /**
     * @method handleToggleMobileMenu
     */
    handleToggleMobileMenu = () => {
        this.setState({
            showMobileMenu: !this.state.showMobileMenu,
            showUserMenu: false,
        });
    };

    /**
     * @method shouldShowProfileMenu
     * @return {*}
     */
    shouldShowProfileMenu = () => {
        const {features} = window.base;

        if (User.belongsToGroup('Service User Family') && !User.data.is_admin) {
            return false;
        }

            return features.allow_profile_change || features.allow_password_change ||
            features.avatar || features.two_factor;
    };

    /**
     * @method getProfileLink
     * @return {string}
     */
    getProfileLink = () => {
        let links = {
            allow_profile_change: '/settings/profile',
            allow_password_change: '/settings/password',
            avatar: '/settings/avatar',
            two_factor: '/settings/two-factor',
            delete_account: '/settings/delete-account'
        };

        const featuresToCheck = [
            'allow_profile_change', 'allow_password_change', 'avatar', 'two_factor', 'delete_account'
        ];
        const {features} = window.base;
        let link = null;

        featuresToCheck.forEach((feature) => {
            if (link === null) {
                if (features[feature]) {
                    link = links[feature];
                }
            }
        });

        return link ?? '';
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        return (
            <div className="relative bg-app-leading select-none">
                <nav className="relative z-10 border-b border-teal-500 border-opacity-25 lg:bg-transparent lg:border-none">
                    <div className="px-4 md:px-8">
                        {this.renderHeader()}
                    </div>

                    {this.renderMobileMenu()}
                </nav>
            </div>
        );
    }

    renderHeader() {
        const {showUserMenu, user} = this.state;

        return (
            <div className="relative h-16 flex items-center justify-between">
                <div className="px-2 flex items-center lg:px-0">
                    <div className="flex-shrink-0">
                        <div
                            className="w-4 h-4 rounded-full bg-app-supporting-yellow"
                        />
                    </div>

                    <div className="hidden lg:block lg:ml-4 lg:space-x-4">
                        <div className="flex">
                            <NavLink
                                to="/"
                                exact={true}
                                className="text-white font-league-spartan text-xl"
                            >
                                Strive
                            </NavLink>
                        </div>
                    </div>
                </div>

                <div className="flex lg:hidden">
                    <button
                        className="p-2 rounded-md inline-flex items-center justify-center text-light-blue-200
                            hover:text-white hover:bg-light-blue-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        aria-expanded="false"
                        onClick={this.handleToggleMobileMenu}
                    >
                        <FontAwesomeIcon icon={faBars}/>
                    </button>
                </div>

                <div className="hidden lg:block lg:ml-4">
                    <div className="flex items-center">
                        <ServiceSwitcher className="mr-4" />

                        {(!User.belongsToGroup('Service User Family') || User.data.is_admin ) && (
                            <>
                                {window.base.features.notifications &&
                                    <HeaderNotifications
                                        onSwitchToTeam={this.handleUpdateTeam}
                                    />
                                }
                            </>
                        )}


                                <div className="relative flex-shrink-0 ml-4">
                                    <div>
                                        <button
                                            className="select-auto rounded-full flex text-sm text-white font-roboto flex items-center"
                                            id="user-menu"
                                            onClick={this.handleToggleUserMenu}
                                        >
                                            {window.base.features.avatar && (
                                                <img
                                                    className="rounded-full h-8 w-8"
                                                    src={User.getAvatarUrl()}
                                                    alt={user?.full_name}
                                                />
                                            )}

                                            {!window.base.features.avatar && (
                                                <React.Fragment>
                                                    <FontAwesomeIcon icon={faUser} className="text-app-typography mr-4" />

                                                    <span className="text-lg font-light font-roboto">
                                                        {user?.full_name}
                                                    </span>
                                                </React.Fragment>
                                            )}
                                        </button>
                                    </div>

                                    {showUserMenu && (
                                        <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                                            {this.renderUserNav()}
                                        </div>
                                    )}
                                </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMobileMenu() {
        const {showMobileMenu, user} = this.state;

        return (
            <div className={`bg-light-blue-900 ${showMobileMenu ? '' : 'hidden'} lg:hidden`}>
                <div className="pt-2 pb-3 px-2 space-y-1">
                    <ServiceSwitcher className="px-3 py-2" />
                    <a
                        href="#"
                        className="block rounded-md py-2 px-3 bg-black bg-opacity-25 text-base font-medium text-white"
                    >
                        Dashboard
                    </a>
                </div>
                <div className="pt-4 pb-3 border-t border-light-blue-800">
                    <div className="flex items-center px-4">
                        {window.base.features.avatar && (
                            <div className="flex-shrink-0">
                                <img
                                    className="rounded-full h-10 w-10"
                                    src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=80h"
                                    alt=""
                                />
                            </div>
                        )}

                        <div className="ml-3">
                            <div className="text-base font-roboto text-white">
                                {user?.full_name}
                            </div>
                            <div className="text-sm font-medium text-light-blue-200">
                                {user?.email}
                            </div>
                        </div>
                        {(!User.belongsToGroup('Service User Family') || User.data.is_admin) && (
                            <button
                                className="ml-auto flex-shrink-0 rounded-full p-1 text-light-blue-200
                                    hover:bg-light-blue-800 hover:text-white focus:outline-none
                                    focus:bg-light-blue-900 focus:ring-2 focus:ring-offset-2
                                    focus:ring-offset-light-blue-900 focus:ring-white"
                            >
                                <FontAwesomeIcon icon={faBell}/>
                            </button>
                        )}
                    </div>

                    <div className="mt-3 px-2">
                        {this.renderUserNav(true)}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderUserNav
     * @param {boolean} mobile
     * @return {JSX.Element}
     */
    renderUserNav = (mobile) => {
        const {user} = this.state;
        const styles = mobile ?
            'block rounded-md py-2 px-3 text-base font-medium text-light-blue-200 hover:text-white hover:bg-light-blue-800' :
            'block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 leading-5';

        const menu = (
            <React.Fragment>
                {this.shouldShowProfileMenu() && (
                    <React.Fragment>
                        <NavLink to={this.getProfileLink()} className={styles}>
                            My Profile
                        </NavLink>

                        <NavLink to="/settings/human-resources/profile" className={styles}>
                            My Hr Profile
                        </NavLink>

                         <NavLink to="/settings/notifications" className={styles}>
                            My Notifications
                        </NavLink>

                         <NavLink to="/settings/notification-settings" className={styles}>
                            My Notification Settings
                        </NavLink>

                        <div className="border-t border-gray-100" />
                    </React.Fragment>
                )}
                {(!User.belongsToGroup('Service User Family') || User.data.is_admin) && (
                    <>
                        {window.base.features.teams && (
                        <React.Fragment>
                            <div className="block px-4 py-2 text-xs text-gray-400">
                                Manage Team
                            </div>

                            <NavLink to={`/teams/${user?.active_team.id}/settings`} className={styles}>
                                Team Settings
                            </NavLink>

                            <NavLink to="/teams/create" className={styles}>
                                Create New Team
                            </NavLink>

                            <div className="border-t border-gray-100" />

                            <div className="block px-4 py-2 text-xs text-gray-400">
                                Switch Team
                            </div>

                            {user?.teams.map(team => (
                                <button
                                    key={team.team_id}
                                    className={`${styles} w-full text-left`}
                                    onClick={() => this.handleUpdateTeam(team.team)}
                                >
                                    {team.team_id === user?.active_team.id && (
                                        <React.Fragment>
                                            <FontAwesomeIcon icon={faCheckCircle} className="text-green-400 mr-2" />
                                        </React.Fragment>
                                    )}
                                    {team.team.name}
                                </button>
                            ))}

                            <div className="border-t border-gray-100" />
                        </React.Fragment>
                    )}
                    </>
                )}

                <NavLink to="/logout" className={styles}>
                    Sign Out
                </NavLink>
            </React.Fragment>
        );

        if (mobile) {
            return menu;
        }

        return (
            <div ref={ref => this.openRef = ref}>
                {menu}
            </div>
        );
    };
}

export default withRouter(Header);
